import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const { textMObj } = typographyStyles;

const COLOR_GREEN_CORRECT_ANSWER = (isBorderColor) =>
  isBorderColor ? "#0f867000" : "#0F867026";
const COLOR_GREY_NOT_ANSWERED = colors.ui.neutral[25];
const COLOR_GREY_WRONG_ANSWER = "#EAEBEC";

const renderColorByStatus = ({
  isSubmitted,
  userSelectedCorrectChoice,
  userHasSelectedQuestion,
  isBorderColor = false,
}) =>
  isSubmitted
    ? !userSelectedCorrectChoice
      ? userHasSelectedQuestion
        ? COLOR_GREY_WRONG_ANSWER
        : COLOR_GREY_NOT_ANSWERED
      : COLOR_GREEN_CORRECT_ANSWER(isBorderColor)
    : COLOR_GREY_NOT_ANSWERED;

export const containerCss = {
  marginBottom: "24px",
};

export const multipleChoiceContainerCss = (
  questionAnswerStatus,
  isReadAloudButtonActive,
) => ({
  backgroundColor: renderColorByStatus(questionAnswerStatus),
  border: `2px solid ${renderColorByStatus({ ...questionAnswerStatus, isBorderColor: true })}`,
  borderRadius: isReadAloudButtonActive ? "4px 4px 0px 0px" : "4px",
  display: "block",
  width: "100%",

  ":hover": {
    backgroundColor: questionAnswerStatus.isSubmitted
      ? null
      : colors.ui.neutral[50],
    cursor: questionAnswerStatus.isSubmitted ? null : "pointer",
  },

  "input:focus-visible + div": {
    backgroundColor: colors.ui.neutral[50],
    border: `2px solid ${colors.ui.core[500]}`,
  },
});

export const multipleChoiceCss = {
  display: "flex",
  position: "relative",
  alignItems: "center",
  color: colors.ui.neutral[500],
  padding: "12px 16px",
};

export const choiceLetterCss = {
  ...textMObj,
  fontWeight: "bold",
  marginRight: "16px",
};

export const choiceTextCss = {
  ...textMObj,
  whiteSpace: "pre-line",
};

export const inputCss = {
  display: "inherit",
  appearance: "none",
  margin: 0,
  padding: 0,
};

export const interactiveMultipleChoiceLabelCss = {
  position: "absolute",
  top: "-10px",
  left: "42px",
};
